import React from "react";
import { object } from "prop-types";

import Carousel from "../../atoms/carousel";
import Headline from "../../atoms/headline";
import Arrow1 from "../../atoms/icons/arrow-1";
import Arrow2 from "../../atoms/icons/arrow-2";
import CardImageType1 from "../card-image-type-1";

import "./carousel-slider.m.css";

const CarouselSlider = ({ collection, options }) => {
  const storiesFromCollection = collection.items.filter(item => item.type === "story");
  const children = storiesFromCollection.map((story, key) => {
    const storyObj = story.story ? story.story : story;
    return <div key={key}>{story && <CardImageType1 story={storyObj} headlineLimit={70} />}</div>;
  });

  return (
    <div styleName="carousel-container">
      <div styleName="headline-container">
        <Headline headline={collection.name} headerLevel={2} headerType={1} />
      </div>

      <Carousel
        carouselName={`carousel-${collection.slug}`}
        options={options}
        totalItems={storiesFromCollection.length}
        showArrows={true}
        renderCenterLeftControls={({ previousSlide, currentSlide }) => {
          return (
            currentSlide !== 0 && (
              <button onClick={previousSlide} className="slider-btn">
                <Arrow2 />
              </button>
            )
          );
        }}
        renderCenterRightControls={({ nextSlide }) => (
          <button onClick={nextSlide} className="slider-btn">
            <Arrow1 />
          </button>
        )}
      >
        {children}
      </Carousel>
    </div>
  );
};

export default CarouselSlider;

CarouselSlider.propTypes = {
  collection: object,
  options: object
};
